<template>
    <el-upload ref="zmupload" v-if="componentShow"
               :action="uploadUrl"
               :headers="reqHeader"
               :data="uploadParam"
               :on-success="success"
               :on-remove="remove"
               :on-progress="progress"
               :on-preview="preview"
               :file-list="fileList"
               :multiple="multiple"
               :before-upload="bfUpload"
               :before-remove="bfRemove"
               :on-error="error"
               :list-type="listType"
               :show-file-list="showFileList"
               :accept="accept"
               :disabled="disabled"
               :drag="drag"
               :limit="limit" >
        <el-button :type="btType" :class="btClass" @click="setUploadHeader" v-if="listType != 'picture-card'" :disabled="disabled">{{$t(i18nPage+btText)}}</el-button>
        <i class="el-icon-plus" v-if="listType == 'picture-card'" @click="setUploadHeader"></i>
        <div slot="tip">
            <slot name="tip" ></slot>
        </div>
        <slot name="trigger"></slot>
    </el-upload>
</template>

<script>
    export default {
        name: "ZmFileUpload",
        beforeCreate() {
            this.i18nPage = 'component.zmFileUpload.';
        },
        props: {
            compclass:{
                type:String
            },
            url:{
                type:String,
                default:'cmn/file/upload'
            },
            btText:{
                type:String,
                default:'点击上传'
            },
            btClass:{
                type:String,
                // default:'zm-button4'
            },
            btType:{
                type:String,
                default:'primary'
            },
            multiple:{
                type:Boolean,
                default:false
            },
            beforeUpload:{
                type:Function
            },
            beforeRemove:{
                type:Function
            },
            onSuccess:{
                type:Function
            },
            onProgress:{
                type:Function
            },
            onRemove: {
                type: Function
            },
            onError:{
                type: Function
            },
            onPreview:{
                type:Function
            },
            fileList:{
                type: Array,
                default() {
                    return [];
                }
            },
            data:{
                type:Object,
                default() {
                    return {};
                }
            },
            listType:{
                type:String,
                default:'text'
            },
            showFileList:{
                type:Boolean,
                default:true
            },
            accept:{
                type:String
            },
            disabled:{
                type:Boolean,
                default:false
            },
            limit:{
                type:Number
            },
            sysType:{
                type:String
            },
            drag:{
                type:Boolean,
                default:false
            },
            fileType:{
                type:String
            }
        },
        data(){
            return {
                i18nPage : 'component.zmFileUpload.',
                reqHeader:{},
                componentShow:true
            }
        },
        computed:{
            uploadUrl: {
                get:function() {
                    if(this.sysType && 'oms' == this.sysType){
                        return process.env.OMS_URL() +this.url;
                    }else{
                        return process.env.BASE_URL() +this.url;
                    }
                }
            },
            uploadParam: {
                get:function () {
                    if(this.fileType){
                        return Object.assign(this.data,{fileType:this.fileType})
                    }
                    return this.data;
                }
            }
        },
        methods: {
            success(response, file, fileList) {
                if(this.onSuccess){
                    this.onSuccess(response, file, fileList);
                }
            },
            remove(file, fileList){
                if(this.onRemove){
                    this.onRemove(file, fileList);
                }
            },
            error(err, file, fileList){
                if(this.onError){
                    this.onError(err, file, fileList);
                }
            },
            preview(file){
                if(this.onPreview){
                    this.onPreview(file);
                }
            },
            progress(event, file, fileList) {
                console.log(event)
                if(this.onProgress){
                    this.onProgress(event, file, fileList);
                }
            },
            bfUpload(file, fileList) {
                if(this.beforeUpload){
                    return this.beforeUpload(file, fileList);
                }
            },
            bfRemove(file, fileList){
                if(this.beforeRemove){
                    return this.beforeRemove(file,fileList)
                }
            },
            setUploadHeader(){
                this.reqHeader = this.$httpService.getRequestHeader(this.uploadParam,this.uploadUrl);
            },
            clearFiles(){
                this.$refs['zmupload'].clearFiles();
            }
        },
        created(){
            this.reqHeader = this.$httpService.getRequestHeader(this.uploadParam,this.uploadUrl);
        },
        beforeDestroy(){
            this.componentShow = false;
        }
    };
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/zmFileUpload/index.vue